import React, { FC } from "react";
import cn from "classnames";
import { Editor } from "@tiptap/react";
import { ButtonVariants } from "src/components/Button/types";
import { Button } from "src/components/Button";
import { IHeadingButton } from "./types";

interface Props extends IHeadingButton {
  editor: Editor;
}
export const HeadingButton: FC<Props> = ({ editor, level, icon: Icon }) => {
  const isActive = editor.isActive("heading", { level });

  const onClick = () => {
    editor.chain().focus().toggleHeading({ level }).run();
  };

  return (
    <Button
      type="button"
      className="!rounded-md !duration-100 !p-1"
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
      onClick={onClick}
    >
      <Icon
        title={`heading ${level}`}
        className={cn("w-5 h-5 transition-colors duration-100", {
          "text-black-base ": !isActive,
          "text-white-base": isActive,
        })}
      />
    </Button>
  );
};
